import { toIntOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type {
    IDonationDetailsMicrositeFormValues,
    IDonationDetailsMicrositeModel,
    IDonationDetailsMicrositeSubmitResult,
} from '@/types/screening/donation-details-microsite';

const DONATION_DETAILS_MICROSITE_ENDPOINT = '/api/register/donation-details-microsite';

const defaultDonationDetailsMicrositeModel: IDonationDetailsMicrositeModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.DonationDetailsMicrosite,

    ddRelationshipToPatient: null,
    ddRecipFirstName: '',
    ddRecipLastName: '',
    recipientAgeText: '',
    recipientCenterName: '',
    micrositeRecipientFullName: '',
    relationshipOptions: [],
};

export const useDonationDetailsMicrosite = (registrationId: number, editKey: string) => {
    const url = `${DONATION_DETAILS_MICROSITE_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultDonationDetailsMicrositeModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<
        IDonationDetailsMicrositeFormValues,
        DashRegistrationStep,
        IDonationDetailsMicrositeSubmitResult
    >(
        url,
        (values) => ({
            ddRelationshipToPatient: toIntOrNull(values.ddRelationshipToPatient),
        }),
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
